import { render, staticRenderFns } from "./BoxesToAccounting.vue?vue&type=template&id=1fcdd086"
import script from "./BoxesToAccounting.vue?vue&type=script&lang=js"
export * from "./BoxesToAccounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports